import React from "react";
import { styleFor } from "./registry";
import MarginNote from "../MarginNote";

/**
 * The post, drawing itself while you fill it in.
 *
 * Sam, 2026-09-16: "i just want to make sure that people can have a fun but
 * effective time posting." Watching the thing appear is the fun part, and it is
 * also the effective part — you can see where the words you are typing will
 * land, and that the photo is not cut off, before anybody else sees it.
 *
 * This renders the SAME template component the wall renders, handed a draft of
 * the post you are writing. It is not a drawing of a post: there is no second
 * layout here to fall out of step with the real one.
 *
 * It also has to render what the CARD draws around that template — the margin
 * notes and the caption — because eight of the nine styles never draw the
 * caption themselves. Without this you could type your words, watch a box
 * headed "How your post will look", and see nothing happen (found by an audit
 * of this PR, 2026-09-16).
 */
function LivePreview({ style, caption, place, whenText, extraNote, attachments, details }) {
  if (!attachments || attachments.length === 0) return null;

  const Body = styleFor(style).Body;
  const draft = {
    id: "draft",
    caption: caption || "",
    attachments,
    style,
    style_details: details || {},
  };
  // A Keepsake writes the caption on the print itself, so the card leaves it
  // out — exactly the rule PostCard follows.
  const captionOnCard = style === "keepsake" ? "" : caption || "";

  return (
    <section
      aria-label="How your post will look"
      className="mt-[12px] rounded-[10px] border border-dashed border-dupontGoldLt/60
                 bg-dupontCream/40 dark:bg-neutral-800/40 p-[10px]"
    >
      <h4 className="m-0 mb-[8px] font-blairBody text-[12px] font-semibold tracking-[0.14em]
                     uppercase text-dupontGoldDk">
        How your post will look
      </h4>
      {/* The white card the wall would draw it on, so the preview is not judged
          against the cream of the form. */}
      <div className="rounded-[8px] bg-white dark:bg-neutral-900 overflow-hidden p-[10px]">
        <MarginNote place={place} whenText={whenText} extraNote={extraNote} />
        <Body post={draft} />
        {captionOnCard && (
          <p className="pt-[11px] mb-0 font-body text-[18px] leading-[1.5]
                        text-gray-800 dark:text-gray-200">
            {captionOnCard}
          </p>
        )}
      </div>
    </section>
  );
}

export default LivePreview;
